<script>
  import { link } from 'svelte-spa-router';
  import { info_client } from '../stores';
  import {goBack} from "../../helpers";
  
  const isMobileApp = JSON.parse(localStorage.getItem('from_mobile')) === true;

  let pictureDefaultMax = "/static/errors_2.png";
  let pictureDefaultMin = "/static/errors-tablet 1.png";
  let screenWidth = window.innerWidth;

  </script>
  
  <div class="main">
    <div class="main_information">
  
      {#if screenWidth > 768}
      <div class="main_picture">
        <img src={pictureDefaultMax} alt/>
      </div>
      {:else}
      <div class="main_picture">
        <img src={pictureDefaultMin} alt/>
      </div>
      {/if}
      <div class="main_text">
        <span class="text_oops text-bold">Упс!</span>
        <span class="text_line text-grey">Что-то пошло не так. Возникла проблема с доступом к разделу</span>
        <span class="text_line text-grey">Без паники!) Обратись за помощью на почту <a href="mailto:info@fizikl.org">info@fizikl.org</a></span>
        <span class="text_id">Твой ID: {$info_client.pk}</span>
        <div class="button-container">
          <button type="button" class="button-back" on:click={() => goBack(isMobileApp)}>Назад</button>
          <a class="button-exit" href='/logout/' use:link>Выйти</a>
        </div>
      </div>
  
    </div>
  </div>
  
  
  
<style>
  .main{
    display: flex;
    justify-content: center;
    margin-top: 100px;
    padding:0 50px 0 50px;
  }
  .main_information{
    max-width: 1070px;
    width:100%;
    display: flex;
    justify-content: start;
    box-shadow: 0px 2px 8px rgba(16, 16, 122, 0.16);
    border-radius: 10px;
  }
  .main_text{
    display: flex;
    flex-direction:column;
    padding: 30px 30px 30px 30px;
  }
  
  .main_picture{
    display: inline-block;
    height: 100%;
    width: 500px;
  }
  
  img{
    width: 100%;
    height: 100%;
    border-radius: 10px 0 0 10px;
  }
  
  .text_oops{
    font-size: 30px;
    line-height: 39px;
    color: #30333D;
    padding-bottom: 16px;
  }
  .text_line {
    font-size: 18px;
    line-height: 26px;
  }
  .text_id{
    font-size: 16px;
    line-height: 23px;
    color: rgba(90, 95, 109, 0.6);
    padding: 16px 0 16px 0;
  }
  a{
    text-decoration: none;
  }

  .button-container {
    display: flex;
    gap: 8px;
  }

  .button-back, .button-exit{
    padding: 14px 18px;
    font-size: 14px;
    line-height: 20px;
    border-radius: 44px;
    cursor: pointer;
    margin-right: 15px;
  }
  .button-back {
    background: #2B50ED;
    color: #FFFFFF;
    border: 2px solid #2B50ED;
  }
  .button-exit {
    background: #FFFFFF;
    color: #2B50ED;
    border: 2px solid #2B50ED;
  }
  
  @media (max-width: 768px){
    .main{
      padding:0 24px 0 24px;
    }
    .main_information{
      display: flex;
      flex-direction:column;
    }
    .main_picture{
      display: inline-block;
      height: 100%;
      width: 100%;
    }
    img{
      border-radius: 10px 10px 0 0;
    }
  }
</style>
  